module.exports = __webpack_public_path__ + "static/media/mega_big.336e7df9.png";